<template>
  <v-tooltip bottom>
    <v-icon  v-if="isOk()" small color="green lighten-1" slot="activator" style="font-size:25px;"
      >check_circle</v-icon
    >
    <v-icon v-if="isWrong()" small color="red lighten-1" slot="activator" style="font-size:25px;"
      >error</v-icon
    >
    <v-icon v-if="isWarning()" small color="yellow darken-3" slot="activator" style="font-size:25px;"
      >pause_circle_filled</v-icon
    >
    <span>{{ incumplimiento }}</span>
  </v-tooltip>
</template>

<script>
import Constants from '../../../../common/constants'

export default {
  props: {
    incumplimiento: String
  },

  methods: {
    isOk () {
      return this.incumplimiento === Constants.IS_FIELD_OK
    },
    isWrong () {
      return this.incumplimiento === Constants.IS_FIELD_WRONG
    },
    isWarning () {
      return this.incumplimiento === Constants.IS_FIELD_WARNING
    }
  }
}
</script>
